
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const { t } = useTranslation();

  const faqs = [
    { qKey: 'faq.q1', aKey: 'faq.a1' },
    { qKey: 'faq.q2', aKey: 'faq.a2' },
    { qKey: 'faq.q3', aKey: 'faq.a3' },
    { qKey: 'faq.q4', aKey: 'faq.a4' },
    { qKey: 'faq.q5', aKey: 'faq.a5' },
    { qKey: 'faq.q6', aKey: 'faq.a6' },
    { qKey: 'faq.q7', aKey: 'faq.a7' },
    { qKey: 'faq.q8', aKey: 'faq.a8' },
  ];

  return (
    <section className="py-24 lg:py-40 bg-[#1e2025]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <span className="inline-block px-5 py-2.5 bg-[#252830] text-gray-300 rounded-full text-base font-bold mb-5 border border-gray-700">
            {t('faq.badge')}
          </span>
          <h2 className="text-5xl lg:text-6xl font-display font-black text-white mb-8">
            {t('faq.title')}
          </h2>
          <p className="text-lg text-gray-400 font-semibold">
            {t('faq.contact')}
          </p>
        </div>

        <div className="space-y-5">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-[#252830] rounded-2xl border-2 border-gray-800 overflow-hidden hover:border-primary/40 transition-colors"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer hover:bg-[#2d3139] transition-colors"
              >
                <div className="flex items-start gap-5 flex-1">
                  <span className="flex-shrink-0 w-7 h-7 rounded-md border-2 border-primary text-primary flex items-center justify-center text-sm font-black mt-1">
                    {index + 1}
                  </span>
                  <h3 className="text-xl font-black text-white flex-1">
                    {t(faq.qKey)}
                  </h3>
                </div>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-3xl text-gray-400 flex-shrink-0 ml-5 transition-transform`}></i>
              </button>
              {openIndex === index && (
                <div className="px-8 pb-6 pl-20">
                  <p className="text-gray-400 leading-relaxed text-base font-medium">
                    {t(faq.aKey)}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
